import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '../../types';
import { apiObservable } from '@support/api';

/* Epic actions */
const sharedContactNotesActions = requestActions('SHARED_CONTACT_NOTE', ['fetchAll']);

/* Component actions */
export const fetchSharedContactNotes = (contactUUID: ID, user: UserSession | null) =>
  sharedContactNotesActions['fetchAll']({ contactUUID, authenticatedUser: !!user });

const fetchSharedContactNotesEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_ALL_SHARED_CONTACT_NOTES'),
    mergeMap(({ payload }) =>
      apiObservable('GET', `/network/shared-contacts/${payload.contactUUID}/notes/all/`, undefined, {
        noAuthorization: !payload.authenticatedUser,
      }).pipe(
        map(({ response }) =>
          sharedContactNotesActions['fetchAllSucceeded']({
            ...response,
            contactUUID: payload.contactUUID,
          }),
        ),
        startWith(
          sharedContactNotesActions['fetchAllRequested']({ contactUUID: payload.contactUUID }),
        ),
        catchError((err) =>
          of(
            sharedContactNotesActions['fetchAllFailed']({
              ...err,
              contactUUID: payload.contactUUID,
            }),
          ),
        ),
      ),
    ),
  );

export const sharedNotesEpic = combineEpics(fetchSharedContactNotesEpic);
